/**
 * Internship Sites Type Definitions
 * Based on API documentation: INTERNSHIP_SITES_API_DOCUMENTATION.md
 */

// Status Enum
export enum EInternshipSiteStatus {
  ACTIVE = "ACTIVE",
  SUSPENDED = "SUSPENDED",
  TERMINATED = "TERMINATED",
}

// Response DTO
export interface InternshipSiteDTO {
  id: string; // UUID
  title: string; // Max 255 characters
  description?: string; // Optional, max 1000 characters
  status: EInternshipSiteStatus;
  councilId: string; // UUID
  councilName: string; // Council name (read-only)
  councilCode: string; // Council code (read-only)
  createdAt: string; // ISO 8601 timestamp
  updatedAt: string; // ISO 8601 timestamp
  deleted: boolean; // Soft delete flag (read-only)
}

// Create Request
export interface InternshipSiteRequest {
  title: string; // Required, max 255 characters
  description?: string; // Optional, max 1000 characters
  status: EInternshipSiteStatus; // Required
  councilId: string; // Required, UUID
}

// Update Request (all fields optional)
export interface InternshipSiteUpdateRequest {
  title?: string; // Optional, max 255 characters
  description?: string; // Optional, max 1000 characters
  status?: EInternshipSiteStatus; // Optional
  councilId?: string; // Optional, UUID
}

// Filters for search operations
export interface InternshipSiteFilters {
  title?: string; // Partial match, case-insensitive
  status?: EInternshipSiteStatus;
  councilId?: string; // UUID
}

// Pagination parameters
export interface InternshipSitePaginationParams {
  page?: number; // 0-indexed, default: 0
  size?: number; // Default: 10
  sortBy?: string; // Default: "createdAt"
  direction?: "asc" | "desc"; // Default: "desc"
}

// Search parameters (combines filters + pagination)
export interface InternshipSiteSearchParams extends InternshipSiteFilters, InternshipSitePaginationParams {}

// Pagination metadata (from API response)
export interface PaginationMeta {
  totalElements: number;
  totalPages: number;
  size: number;
  number: number; // Current page (0-indexed)
  first: boolean;
  last: boolean;
}

// Paginated response structure
export interface PagedInternshipSiteResponse {
  data: InternshipSiteDTO[];
  meta: {
    pagination: PaginationMeta;
  };
}

// Title existence check response (returns boolean)
export type InternshipSiteExistsResponse = boolean;
